export default [
    {
        path: '/governance/lock-rules',
        name: 'governance-lock-rules',
        component: () => import('./pages/LockRulesIndex'),
        meta: {
            title: 'Configurações de Bloqueio',
            icon: 'mdi-shield-lock-outline',
            breadcrumbs: [
                { text: 'Governança', disabled: true },
                { text: 'Configurações de Bloqueio', disabled: true },
            ],
        },
    },
]
